/**
 * Reset Faulted Pane Constants
 *
 * Copy and identifiers for the pane that resets every selected faulted device.
 */

/** Title of the Reset Faulted pane. */
export const RESET_FAULTED_TITLE = 'Reset Faulted';

/** Label of the save-bar action that clears the selection (same copy as bulk edit). */
export const DISCARD_ACTION_LABEL = 'DISCARD CHANGES';

/** Target shown in the confirm dialog for a device without a mode. */
export const MODELESS_RESET_LABEL = 'Reset fault';

/** Current state shown in the confirm dialog for every device being reset. */
export const FAULTED_STATUS_LABEL = 'Faulted';

/** Group heading of the confirm dialog's device list. */
export const RESET_FAULTED_GROUP_LABEL = 'Reset Faulted Equipment';

/** Placeholder for a cell with no value (modeless devices, missing fault reason). */
export const EMPTY_CELL_LABEL = '—';

/** Placeholder of the Mode dropdown when no mode is chosen yet. */
export const SELECT_MODE_PLACEHOLDER = 'Select Mode';

/** Row checkbox tooltip when a device has mode options but no mode resolved. */
export const MISSING_MODE_MESSAGE = 'Select a mode to reset this device.';

/** Select-all tooltip when no row can be selected. */
export const NO_SELECTABLE_DEVICES_MESSAGE = 'No devices can be selected';

/** DataTable id of the Reset Faulted table (also scopes its cached state). */
export const RESET_FAULTED_TABLE_ID = 'reset-faulted-table';

/** Column ids of the Reset Faulted table. */
export const RESET_FAULTED_COLUMN_IDS = {
  NAME: 'name',
  EQUIPMENT_TYPE: 'equipment-type',
  FAULT_REASON: 'fault-reason',
  MODE: 'mode',
} as const;
